// @flow
import * as React from 'react';
import { isSellerFollowed, submitFollowSeller, submitUnfollowSeller } from '../../redux/modules/followSeller';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FollowSellerButton from './FollowSellerButton';
import FollowSellerLink from './FollowSellerLink';
import isEqual from 'react-fast-compare';
import ShouldLogInContainer from '../../components/ShouldLogIn/ShouldLogInContainer';

const mapStateToProps = (state, { sellerId }) => {
    const followed = isSellerFollowed(state, sellerId);
    return {
        followed,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            submitFollowSeller,
            submitUnfollowSeller,
        },
        dispatch
    );

type Props = {
    button: boolean,
    children: React.Node,
    followed: boolean,
    longText: boolean,
    primaryWithSecondarySuccess: boolean,
    secondary: boolean,
    sellerId: number,
    small: boolean,
    submitFollowSeller: Function,
    submitUnfollowSeller: Function,
};

class FollowSellerContainer extends React.Component<Props> {
    static defaultProps = {
        button: false,
        primaryWithSecondarySuccess: false,
        secondary: false,
        small: false,
    };

    shouldComponentUpdate = nextProps => !isEqual(this.props, nextProps);

    toggleFollowSeller = () => {
        if (!this.props.followed) {
            this.props.submitFollowSeller(this.props.sellerId);
        } else {
            this.props.submitUnfollowSeller(this.props.sellerId);
        }
    };

    render() {
        const { button, children, followed, longText, primaryWithSecondarySuccess, secondary, small } = this.props;

        const content = button ? (
            <FollowSellerButton
                followed={followed}
                longText={longText}
                primaryWithSecondarySuccess={primaryWithSecondarySuccess}
                secondary={secondary}
                small={small}
            >
                {children}
            </FollowSellerButton>
        ) : (
            <FollowSellerLink followed={followed}>{children}</FollowSellerLink>
        );

        return (
            <ShouldLogInContainer requireLogin runFunction={this.toggleFollowSeller}>
                <span>{content}</span>
            </ShouldLogInContainer>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowSellerContainer);
